import { IBoardUserMeta } from 'app/store/model/boardUserMeta/types';
import { AT_UPDATE, TBoardUserMetaAction } from 'app/store/model/boardUserMeta/actions/types';

const initialState: IBoardUserMeta = {};
export const  getInitialState = () => {
    return {...initialState};
};

export const boardUserMetaReducer = (
    state = initialState,
    action: TBoardUserMetaAction
): IBoardUserMeta  => {
    switch (action.type) {
        case AT_UPDATE: {
            const { boardUserMeta } = action;
            return {
                ...state,
                ...boardUserMeta
            }
        }
        default: {
            return state;
        }
    }
};
